import style from "../style.module.sass"
import { useStores } from "../../../../../hooks";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import staffCalled from "./../assets/waiterCalled.svg";
import OrdinaryCircleLoader from "../../../../../components/ordinaryCircleLoader";
import { StaffCallKind } from "../../../../../services/menu/models";

const StaffCall = () => {
    const { menuStore, generalStore, generalMenuStore } = useStores();
    const { i18n, t } = useTranslation(['menu']);
    const isStaffCallWanted = menuStore.isStaffCallWanted;
    const calledStaffCall = menuStore.calledStaffCall;
    const availableStaffCalls = menuStore.availableStaffCalls;
    const tableId = generalStore.tableId;
    const [topOffset, setTopOffset] = useState(60);
    const [opacity, setOpacity] = useState(1);
    const [pendingKind, setPendingKind] = useState<StaffCallKind | null>(null);
    const blockRef = useRef<HTMLDivElement>(null)

    const buttonsColor = menuStore.menu?.data?.themeSettings?.buttonsBackgroundColor || '#FF2C3D'

    useEffect(() => {
        if (!isStaffCallWanted) {
            menuStore.setCalledStaffCall(null);
            setPendingKind(null);
            setTopOffset(window.innerHeight);
            setOpacity(0);
        } else {
            if (blockRef.current) {
                setTopOffset(window.innerHeight - blockRef.current.clientHeight - 20);
            }
            setOpacity(1);
        }
    }, [isStaffCallWanted, blockRef.current]);

    const classes = [style.isWaiterWantedSection];
    if (isStaffCallWanted) {
        classes.push(style.openWaiterCall)
    }

    const table = menuStore.getTableByPublicId(tableId);

    const closeStaffCall = () => {
        menuStore.isStaffCallWanted = false;
        generalMenuStore.isOverlayOpen = false;
        generalMenuStore.onOverlayClick = undefined;
        document.body.style.overflow = 'auto';
    };

    const callStaff = async (kind: StaffCallKind) => {
        if (!table || pendingKind) return;

        setPendingKind(kind);
        await menuStore.callStaff(kind);
        setPendingKind(null);
    };

    return (
        <div className={classes.join(" ")}
             style={{ top: topOffset, opacity }}
        >
            {!calledStaffCall ?
                <div className={style.waiter} ref={blockRef}>
                    <p>{t("menu:staffCall.title")}</p>
                    <p>{t("menu:staffCall.subtitle")}</p>
                    <div className={style.table}>{table?.data.title[i18n.language]}</div>
                    {!table ?
                        <div className={[style.waiterButton, style.disabled].join(" ")}>
                            <span>{t("menu:staffCall.impossible")}</span>
                        </div>
                        :
                        <div className={style.staffCallButtons}>
                            {availableStaffCalls.map((kind) => (
                                <div key={kind}
                                     className={[style.waiterButton, pendingKind ? style.disabled : ""].join(" ")}
                                     style={pendingKind ? undefined : { background: buttonsColor }}
                                     onClick={() => callStaff(kind)}
                                >
                                    <span>{pendingKind === kind ? "" : t(`menu:staffCall.kinds.${kind}`)}</span>
                                    {pendingKind === kind &&
										<OrdinaryCircleLoader color={`${buttonsColor} transparent transparent transparent`}/>}
                                </div>
                            ))}
                        </div>
                    }
                </div>
                :
                <div className={style.waiterCalled}
                     onClick={closeStaffCall}
                     ref={blockRef}
                >
                    <img src={staffCalled} alt='staff called'/>
                    <p>{t(`menu:staffCall.confirmation.${calledStaffCall}`)}</p>
                    <div className={style.buttonToMenu}>{t("menu:staffCall.back")}</div>
                </div>
            }
        </div>
    )
}

export default observer(StaffCall);
